<template>
  <div id='ComoFunciona'>
		<b-container>
			<b-row>
        <b-col sm=5 >
          <h3 class="celular-protegido">
            Contrate em 3 passos:
          </h3>
          <p class="descricao-protegido">
            Oferecemos a proteção que o seu aparelho precisa. <br />
            Contrate agora, fique bem mais protegido.
          </p>
          <b-row>
            <b-col sm=3 class="icone-passos">
              <img height="104" width="104" loading="lazy" src="../../assets/svg/01.svg" alt="01">
            </b-col>
            <b-col sm=9 class="descricao-passos">
              Informe seus dados e o modelo do aparelho
            </b-col>
          </b-row>
          <b-row>
            <b-col sm=3 class="line">
              <img height="33" width="3" loading="lazy" src="../../assets/svg/line.svg" alt="line">
            </b-col>
            <b-col sm=9 class="descricao-passos">
            </b-col>
          </b-row>
          <b-row>
            <b-col sm=3 class="icone-passos">
              <img height="104" width="104" loading="lazy" src="../../assets/svg/02.svg" alt="02">
            </b-col>
            <b-col sm=9 class="descricao-passos">
              Escolha a cobertura desejada
            </b-col>
          </b-row>
          <b-row>
            <b-col sm=3 class="line">
              <img height="33" width="3" loading="lazy" src="../../assets/svg/line.svg" alt="line">
            </b-col>
            <b-col sm=9 class="descricao-passos">
            </b-col>
          </b-row>
          <b-row>
            <b-col sm=3 class="icone-passos">
              <img height="104" width="104" loading="lazy" src="../../assets/svg/03.svg" alt="03">
            </b-col>
            <b-col sm=9 class="descricao-passos">
              Inclua os dados para pagamento
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import './ComoFunciona.css'
export default {
  name: 'ComoFunciona'
}
</script>
